if (!customElements.get('product-model')) {
  customElements.define(
    'product-model',
    class ProductModel extends DeferredMedia {
      constructor() {
        super();
      }

      loadContent() {
        super.loadContent();

        Shopify.loadFeatures([
          {
            name: 'model-viewer-ui',
            version: '1.0',
            onLoad: this.setupModelViewerUI.bind(this),
          },
        ]);
      }

      setupModelViewerUI(errors) {
        if (errors) return;

        this.modelViewerUI = new Shopify.ModelViewerUI(this.querySelector('model-viewer'));
      }
    }
  );
}

window.ProductModel = {
  loadShopifyXR() {
    Shopify.loadFeatures([
      {
        name: 'shopify-xr',
        version: '1.0',
        onLoad: this.setupShopifyXR.bind(this),
      },
    ]);
  },

  setupShopifyXR(errors) {
    if (errors) return;

    if (!window.ShopifyXR) {
      document.addEventListener('shopify_xr_initialized', () => this.setupShopifyXR());
      return;
    }

    document.querySelectorAll('[id^="ProductJSON-"]').forEach((modelJSON) => {
      window.ShopifyXR.addModels(JSON.parse(modelJSON.textContent));
      modelJSON.remove();
    });
    window.ShopifyXR.setupXRElements();
  },
};

window.addEventListener('DOMContentLoaded', () => {
  if (window.ProductModel) window.ProductModel.loadShopifyXR();
});


/* mercury: studio look */
(() => {
  const STUDIO = {
    'shadow-intensity': '1',
    'shadow-softness': '0.9',
    exposure: '1.05',
    'camera-orbit': '22deg 74deg auto',
    'interaction-prompt': 'none',
  };
  const style = (mv) => {
    if (!mv || mv.dataset.mercuryStudio) return;
    mv.dataset.mercuryStudio = '1';
    for (const k in STUDIO) mv.setAttribute(k, STUDIO[k]);
  };
  const scan = (root) => {
    if (!root || root.nodeType !== 1) return;
    if (root.matches && root.matches('model-viewer')) style(root);
    if (root.querySelectorAll) root.querySelectorAll('model-viewer').forEach(style);
  };
  new MutationObserver((muts) => muts.forEach((m) => m.addedNodes.forEach(scan)))
    .observe(document.documentElement, { childList: true, subtree: true });
  document.addEventListener('DOMContentLoaded', () => scan(document.body));
})();
